import { Link } from '@tanstack/react-router'
import { useAtomValue } from 'jotai'
import { Button } from '@duck/ui'
import { useTar } from '@/modules'
import { isAuthenticatedAtom } from '@/store/userAtoms'

export const HiddenSharePage = () => {
  const { t } = useTar()
  const isAuthenticated = useAtomValue(isAuthenticatedAtom)
  return (
    <div className="max-w-[480px] mx-auto py-16 text-center">
      <h1 className="text-2xl font-semibold mb-3">{t('share.hidden.title')}</h1>
      <p className="text-muted-foreground mb-8 leading-relaxed">{t('share.hidden.body')}</p>
      <div className="flex gap-3 justify-center">
        {isAuthenticated ? (
          <Button asChild variant="default">
            <Link to="/">{t('share.hidden.goToHomepage')}</Link>
          </Button>
        ) : (
          <>
            <Button asChild variant="default">
              <Link to="/auth/signup">{t('common.signup')}</Link>
            </Button>
            <Button asChild variant="outline">
              <Link to="/auth/login">{t('share.publicPage.logIn')}</Link>
            </Button>
          </>
        )}
      </div>
    </div>
  )
}
